export enum RavFlow {
  Spot = 'spot',
  SpotChallenge = 'spotChallenge',
  AutomaticConfirm = 'automaticConfirm',
  AutomaticChallenge = 'automaticChallenge',
  AutomaticCancellationChallenge = 'automaticCancellationChallenge',
  NextDayAutomaticChallenge = 'nextDayAutomaticChallenge',
  SameDayAutomaticChallenge = 'sameDayAutomaticChallenge',
  OneSpotConfirmChallenge = 'oneSpotConfirmChallenge',
  OneAutomaticContractChallenge = 'oneAutomaticContractChallenge',
  OneAutomaticDeactivateChallenge = 'oneAutomaticDeactivateChallenge',
  OneSpotSimulate = 'oneSpotSimulate'
}

export enum RavStatus {
  SpotConfirmFailed = 'spotConfirmFailed',
  AutomaticConfirmFailed = 'automaticConfirmFailed',
  ChallengeFailed = 'challengeFailed',
  SpotSimulateFailed = 'spotSimulateFailed'
}

export const RavScreen = {
  SpotConfirm: 'spotConfirm',
  AutomaticConfirm: 'automaticConfirm',
  SpotChallenge: 'spotChallenge',
  AutomaticChallenge: 'automaticChallenge',
  AutomaticCancellationChallenge: 'automaticCancellationChallenge',
  NextDayAutomaticChallenge: 'nextDayAutomaticChallenge',
  SameDayAutomaticChallenge: 'sameDayAutomaticChallenge',
  OneSpotConfirmChallenge: 'oneSpotConfirmChallenge',
  OneAutomaticContractChallenge: 'oneAutomaticContractChallenge',
  OneAutomaticDeactivateChallenge: 'oneAutomaticDeactivateChallenge',
  OneSpotSimulate: 'oneSpotSimulate'
} as const

export const generalSettings = {
  owner: 'antecipacao',
  product: 'rav',
  project: 'stone'
}
